<template>
  <div class="order-date-picker">
    <ul
      :class="['date-list', `date-list-${product.slug}`]"
      ref="dateList"
      data-testid="date-list"
    >
      <li
        v-for="(date, i) in dateList"
        :key="i"
        :class="getDateItemClass(date, i)"
        @click="onDateClick(date)"
        class="date-item"
        ref="dateItem"
      >
        <div class="date">
          <template v-if="i === 0">今日</template>
          <template v-else>{{ formatDate(date) }}</template>
        </div>
        <div class="day">{{ getDayLabel(date) }}</div>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from "vue-facing-decorator";
import { deviceModule } from "@/store/device";
import "swiper/swiper-bundle.css";
import {
  formatFromUnixTimestamp,
  getDay,
  getDayLabel,
  isSameDay
} from "@/utils/date";
import { authStore } from "@/store/auth";

@Component({
  components: {}
})
export default class OrderDatePicker extends Vue {
  @Prop({ type: Number, required: true })
  selectedDate!: number;
  @Prop({ type: Array, required: true })
  dateList!: number[];

  mounted() {
    this.scrollToSelectedDate({ disabledSmoothScroll: true });
  }

  formatDate(date: number) {
    return formatFromUnixTimestamp(date, "M/d");
  }

  isActive(date: number) {
    return isSameDay(this.selectedDate, date);
  }

  getDayLabel(date: number) {
    return getDayLabel(date);
  }

  getDay(date: number) {
    return getDay(date);
  }

  getDateItemClass(date: number, index: number) {
    const classes = [];
    if (index === 0) {
      classes.push("today");
    }
    const day = this.getDay(date);
    if (day === 7) {
      classes.push("sun");
    } else if (day === 6) {
      classes.push("sat");
    }
    if (this.isActive(date)) {
      classes.push("is-active");
    }
    return classes;
  }

  get isIos() {
    return deviceModule.isIos;
  }

  get product() {
    return authStore.product;
  }

  /**
   * 日付がクリックされた時のイベント
   * @param date クリックされた日付
   */
  onDateClick(date: number) {
    // @ts-ignore
    this.$emit("select", date, this.$refs.dateList.scrollLeft);
  }

  scrollToSelectedDate({
    disabledSmoothScroll
  }: {
    disabledSmoothScroll: boolean;
  }) {
    this.$nextTick(() => {
      const activeDateIndex = this.dateList.findIndex(date =>
        this.isActive(date)
      );
      if (activeDateIndex === 0) {
        const element = this.$refs.dateList as Element;
        element.scrollTo({
          behavior: "smooth",
          left: 0
        });
        return;
      }
      (this.$refs.dateItem as HTMLLIElement[])?.[
        activeDateIndex
      ]?.scrollIntoView({
        behavior: disabledSmoothScroll ? undefined : "smooth",
        inline: "center"
      });
    });
  }

  @Watch("selectedDate")
  onChangeSelectedDate() {
    this.scrollToSelectedDate({ disabledSmoothScroll: false });
  }
}
</script>
<style lang="scss" scoped>
.order-date-picker {
  position: relative;
  padding: 12px 0 8px;
  background-color: $white;
}

.date-list {
  display: flex;
  padding: 0 0 0 12px;
  padding-left: calc(15vw + 28px);
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }

  &::before {
    position: absolute;
    left: 0;
    z-index: 1;
    display: block;
    width: calc(15vw + 21px);
    height: 56px;
    content: "";
    background: $white;
    border-right: 1px solid $gray-03;
  }
}

.date-item {
  position: relative;
  min-width: 15vw;
  padding: 4px 4px 20px;
  margin-right: 8px;
  text-align: center;
  background: $white;
  border: 1px solid $gray-03;
  border-radius: 8px;

  &.is-active {
    background: $secondary;
    border-color: $secondary;
  }

  &.today {
    position: fixed;
    left: 12px;
    z-index: 10;
  }
}

.date {
  margin-bottom: 2px;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: $primary-dark;

  .today & {
    font-size: 14px;
  }

  .is-active & {
    color: $primary-text;
  }
}

.day {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding-bottom: 8px;
  font-size: 12px;
  line-height: 1;
  color: $gray-05;
  text-align: center;

  .is-active & {
    color: $primary-text;
  }

  .sun & {
    color: $red;
  }

  .sat & {
    color: $blue;
  }
}

.date-list-caitech_pharmacist {
  .date-item {
    &.is-active {
      background: #03a99d;
      border-color: #03a99d;

      .date {
        color: white;
      }

      .day {
        color: white;
      }
    }
  }
}
</style>
